module.exports = __webpack_public_path__ + "media/stop-16.d5738dcc.mp3";